import * as React from 'react';
import { ToastMessage } from '@blazemeter/blaze-ct-ui-components';
import { IToast } from 'store/ui/toasts/toastsTypes';

interface ToastProps {
  toast: IToast;
  hideToast: () => void;
}

const variantMapping: Array<'info' | 'success' | 'danger' | 'warning'> = ['info', 'success', 'danger', 'warning'];

const Toast = ({ toast: { heading, type, content, timeout }, hideToast }: ToastProps) => {
  const variant = variantMapping[type];
  const toastProps = {
    text: content,
    header: heading,
    variant: variant,
    onRemove: hideToast,
  };
  return (
    <ToastMessage duration={timeout != null ? timeout : variant === 'danger' ? undefined : 5000} {...toastProps} />
  );
};

export default Toast;
